<template>
	<div class="lms-launch-screen">
		<div class="launch-container">
			<img
				class="pronto-launch-header"
				src="/images/pronto/pronto-launch-header.svg"
				alt="LMS Launch"
			/>
			<p class="launch-description">
				Your school is using Pronto for real-time class communication.
			</p>
			<a class="launch-button" :href="current_url" target="_blank"
				>Launch Pronto</a
			>
			<img
				class="pronto-devices"
				src="/images/pronto/pronto-devices.svg"
				alt=""
			/>
			<p class="launch-footer">
				By launching Pronto you agree to the
				<a href="https://pronto.io/user-terms/">Terms of Service</a> &
				<a href="https://pronto.io/privacy/">Privacy Policy</a>
			</p>
		</div>
	</div>
</template>

<script>
import store from '../store'
import { post } from '../helpers/api'

export default {
	data() {
		return {
			store,
		}
	},

	computed: {
		current_url() {
			var href = document.location.href
			var groupid = new URLSearchParams(document.location.search).get('groupid')
			var from = new URLSearchParams(document.location.search).get('from')
			console.log(document.location)
			return (
				href.replace('external_launch', 'chat').replace(/\?.+$/, '') +
				'/' +
				groupid +
				'?integration=' +
				from
			)
		},
	},

	created() {
		if (!this.store.auth.user.acceptedtos) {
			this.acceptTerms()
		}
	},

	methods: {
		acceptTerms() {
			post('/api/v1/user.accepttos')
				.then(({ data }) => {
					this.store.auth.user.acceptedtos = data.user.acceptedtos
				})
				.catch((error) => {
					console.error(error)
				})
		},
	},
}
</script>

<style lang="scss" scoped>
@import url('https://fonts.googleapis.com/css?family=Poppins%3A300%2C500italic%7CMontserrat%3A600%2C800%2C700%2C300&amp;ver=1583740711');
@import 'src/sass/variables';

@media screen and (max-height: 1030px) {
	.pronto-devices {
		display: none !important;
	}
}

@media screen and (max-width: 600px) {
	.launch-container {
		width: 550px !important;
	}

	.pronto-launch-header {
		width: 200px !important;
	}

	.launch-description {
		width: 440px !important;
		font-size: 20px !important;
		margin: 0 auto 25px !important;
	}

	.launch-button {
		width: 156px !important;
		height: unset !important;
		font-size: 12px !important;
		padding: 15px 30px !important;
		margin: 0 auto 30px !important;
	}

	.launch-footer {
		font-size: 15px !important;
	}
}

.lms-launch-screen {
	position: absolute;
	top: 0;
	right: 0;
	bottom: 0;
	left: 0;
	width: 100%;
	height: 100%;
	background-color: var(--teal-300);
}

.launch-container {
	width: 630px;
	margin: 0 auto;
}

.pronto-launch-header {
	margin: 58px auto 44px;
	display: block;
}

.launch-description {
	width: 540px;
	height: 64px;
	font-family: Montserrat;
	font-size: 26px;
	font-weight: 600;
	text-align: center;
	color: #04a187;
	margin: 0 auto 44px;
}

.launch-button {
	width: 256px;
	height: 66px;
	border-radius: 33px;
	background-color: #448de6;
	font-family: Montserrat;
	font-size: 18px;
	font-weight: 600;
	text-align: center;
	text-decoration: none;
	color: #ffffff;
	padding: 22px 58px;
	margin: 0 auto 55px;
	display: block;
}

.pronto-devices {
	display: block;
	margin: 0 auto 40px;
}

.launch-footer {
	width: 390px;
	font-family: Montserrat;
	font-size: 16px;
	font-weight: 600;
	text-align: center;
	color: #ffffff;
	margin: 0 auto;
	display: block;
}

.launch-footer a,
.launch-footer a:visited {
	color: #ffffff;
}
</style>
